export const ADD_STATE_TIMEOUT = 2500;

export enum ButtonState {
  Adding = 'ADDING',
  Added = 'ADDED',
  Add = 'ADD',
}

export type AddonButtonProps = {
  onClick(): Promise<void>;
  outOfStock?: boolean;
};
